import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../lib/firebase";

/**
 * Single source of truth for a customer's spendable balance: wallets/{uid}.balance
 * (users.walletBalance is only a server-maintained mirror). Falls back to the mirror
 * when the wallet doc doesn't exist yet — same rule the server uses.
 */
export const useLiveWallet = (uid?: string | null, mirrorBalance?: number) => {
  const [balance, setBalance] = useState<number>(0);
  const [loaded, setLoaded] = useState(false);
  const [exists, setExists] = useState(false);

  useEffect(() => {
    if (!uid) {
      setLoaded(false);
      return;
    }
    const unsub = onSnapshot(
      doc(db, "wallets", uid),
      (snap) => {
        setExists(snap.exists());
        setBalance(snap.exists() ? Number(snap.data()?.balance || 0) : Number(mirrorBalance || 0));
        setLoaded(true);
      },
      (err) => {
        console.warn("wallet listener failed", err);
        setBalance(Number(mirrorBalance || 0));
        setLoaded(true);
      }
    );
    return () => unsub();
  }, [uid, mirrorBalance]);

  return { balance: Math.round(balance * 100) / 100, loaded, exists };
};
